// import {
//   countries as countriesData,
//   timeZone,
// } from "../../../resources/LocationData";
import { useEffect, useState } from "react";
import Styles from "./locationStyle.module.css";
import { toast, ToastContainer } from "react-toastify";
import { CiEdit } from "react-icons/ci";
import {
  DatePicker,
  Select,
  Button,
  Form,
  Input,
  Checkbox,
} from "antd";

const HardwareDetailsComponent = ({ hardwareDetails, setHardwareDetails, nonMandateHardwareDetails, setNonMandateHardwareDetails, isApprover, approvalStage, siteStatus, setSiteStatus, isApproverView }) => {
  const [form] = Form.useForm();
    const { Option } = Select;  
  

  const submitForm = (isCompleted) => {
    if (isCompleted) {
      if (
        Object.values(hardwareDetails).filter((value) => value !== null)
          .length === Object.values(hardwareDetails).length
      ) {
        form.submit();
        setHardwareDetails((prev) => ({
          ...prev,
          isSectionCompleted: true,
        }));
        // Submit the form
      } else {
        setHardwareDetails((prev) => ({
          ...prev,
          isSectionCompleted: false,
        }));
        // Reset the checkbox in the form
        form.setFieldsValue({
          isSectionCompleted: false,
        });

        toast.error(
          "Please fill all the details before marking the section as completed."
        );
      }
    }
  };

 const handleWifiResponsibilityChange = (isSiteResponsible) => {
  // console.log("hardware details in change: ", hardwareDetails)
  // console.log("non mandate  ", nonMandateHardwareDetails)
    // wifiProvider: selectedSite?.wifiProvider || null,
    //       wifiKitShipped: selectedSite?.wifiKitShipped || null,
    //       wifiShippedDate: selectedSite?.wifiShippedDate ? dayjs(selectedSite?.wifiShippedDate) : null,
    //       wifiInstallDate: selectedSite?.wifiInstallDate ? dayjs(selectedSite?.wifiInstallDate) : null,
    //       wifiInstalled: selectedSite?.wifiInstalled || null,
    if(isSiteResponsible){
        setNonMandateHardwareDetails({
            wifiProvider: null,
            wifiKitShipped: null,
            wifiShippedDate: null,
            wifiInstallDate: null,
            wifiInstalled: null
        })
        const {wifiProvider, wifiKitShipped, wifiShippedDate, wifiInstallDate, wifiInstalled, ...restOfHardwareDetails} = hardwareDetails
        setHardwareDetails({
            ...restOfHardwareDetails, isSiteResponsibleForWifi: isSiteResponsible
        })
        form.setFieldValue('isSiteResponsibleForWifi', isSiteResponsible)
        form.setFieldValue('wifiProvider', null)
        form.setFieldValue('wifiKitShipped', null)
        form.setFieldValue('wifiShippedDate', null)
        form.setFieldValue('wifiInstallDate', null)
        form.setFieldValue('wifiInstalled', null)
    }else{
        setNonMandateHardwareDetails({})
        setHardwareDetails((prev) => ({
            ...prev,
            isSiteResponsibleForWifi: isSiteResponsible,   
            wifiProvider: null,
            wifiKitShipped: null,
            wifiShippedDate: null,
            wifiInstallDate: null,
            wifiInstalled: null
        }))
        form.setFieldValue('isSiteResponsibleForWifi', isSiteResponsible)
        form.setFieldValue('wifiProvider', null)
        form.setFieldValue('wifiKitShipped', null)
        form.setFieldValue('wifiShippedDate', null)
        form.setFieldValue('wifiInstallDate', null)
        form.setFieldValue('wifiInstalled', null)
    }
        // onChange={(e) => {
            //     setHardwareDetails(prev => ({
            //       ...prev,
            //       isSiteResponsibleForWifi: e.target.checked
            //   }));
              
            // }}
 }


  return (
    <div className={Styles[`main-div`]}>
      <div className={Styles["location-head-div"]}>
        <div>
          <span>
            {" "}
            {hardwareDetails?.isSectionCompleted && isApprover && isApproverView && (
              <Button
                className={Styles["edit-btn"]}
                disabled={!hardwareDetails?.isSectionCompleted || siteStatus === "Live" || siteStatus === "Pre Live" || approvalStage !== 'PendingApproval'}
                onClick={() => {
                  setHardwareDetails((prev) => ({
                    ...prev,
                    isSectionCompleted: false,
                  }));
                  form.setFieldsValue({
                    isSectionCompleted: false,
                  });
                }}
              >
                {" "}
                <CiEdit  
                  className={Styles["location-edit-icon"]}
                />{" "}
                Edit
              </Button>
            )}
          </span>
        </div>
      </div>

      <Form
        className={Styles["form-grid"]}
        form={form}
        initialValues={hardwareDetails}
        disabled={hardwareDetails?.isSectionCompleted || (approvalStage === "Approved") || (approvalStage === "PendingApproval" && isApprover === false)}
      >
        <h6>Hardware Details</h6>
        <Form.Item
          name="hardwareCompany"
          label="Hardware Company"
          rules={[{ required: true, message: "Please input hardware company!" }]}
        >
           <Input
            onChange={(e) => {
              setHardwareDetails((prev) => ({
                ...prev,
                hardwareCompany: e.target.value,
              }));
            }}
          ></Input>
        </Form.Item>

        <Form.Item
          label="Hardware Shipped"
          name="hardwareShipped"
          rules={[{ required: true, message: "Please input hardware shipped!" }]}>
          <Select
                      // value={locationDetails?.country}
                      onChange={(value) => {
                        setHardwareDetails((prev) => ({
                          ...prev,
                          hardwareShipped: value,
                        }));
                      }}
                      placeholder="Hardware Shipped"
                      allowClear
                    >
                        <Option value="Yes">Yes</Option>
                        <Option value="No">No</Option>
                    </Select>
        </Form.Item>

        <Form.Item
          name="hardwareShipDate"
          label="Hardware Shipped Date"
          rules={[{ required: true, message: "Please input hardware shipped Date!" }]}
        >
          <DatePicker onChange={(date)=>{
            setHardwareDetails(prev => ({
              ...prev,
              hardwareShipDate: date ? new Date(date) : null
            }))
          }}/>
        </Form.Item>

         <Form.Item
          name="hardwareInstallDate"
          label="Hardware Installed Date"
          rules={[{ required: true, message: "Please input hardware installed date!" }]}
        >
          <DatePicker onChange={(date)=>{
            setHardwareDetails(prev => ({
              ...prev,
              hardwareInstallDate: date ? new Date(date) : null
            }))
          }}/>
        </Form.Item>

        <Form.Item name="hardwareInstalled" label="Hardware Installed">

          <Select value={hardwareDetails.hardwareInstalled} onChange={value => setHardwareDetails(prev => ({
            ...prev,
            hardwareInstalled: value
          }))}>
            <Option value={true}>Yes</Option>
            <Option value={false}>No</Option>

          </Select>

          {/* <Checkbox
            onChange={(e) => {
                setHardwareDetails(prev => ({
                  ...prev,
                  hardwareInstalled: e.target.checked
              }));
              
            }}
          >
            {" "}
            Hardware Installed.
          </Checkbox> */}
        </Form.Item>

        <h6>Wifi Details</h6>
        
        <Form.Item name="isSiteResponsibleForWifi" label="Is site responsible for WIFI?">

          <Select value={hardwareDetails.isSiteResponsibleForWifi} onChange={value => handleWifiResponsibilityChange(value)}>
            <Option value={true}>Yes</Option>
            <Option value={false}>No</Option>

          </Select>

          {/* <Checkbox
          onChange={(e) => {
                        handleWifiResponsibilityChange(e.target.checked)
                      }}
            // onChange={(e) => {
            //     setHardwareDetails(prev => ({
            //       ...prev,
            //       isSiteResponsibleForWifi: e.target.checked
            //   }));
              
            // }}
          >
            {" "}
            Is the site responsible for wifi.
          </Checkbox> */}
        </Form.Item>

        <Form.Item
          name="wifiProvider"
          label="Wifi Provider"
          rules={[{ required: (!Object.keys(hardwareDetails).includes('wifiProvider')) ? false : true, message: "Please input wifi provider!" }]}
        >
           <Input
           disabled={!Object.keys(hardwareDetails).includes('wifiProvider')}
            onChange={(e) => {
              setHardwareDetails((prev) => ({
                ...prev,
                wifiProvider: e.target.value,
              }));
            }}
          ></Input>
        </Form.Item>

         <Form.Item
          label="Wifi Kit Shipped"
          name="wifiKitShipped"
          rules={[{ required: (!Object.keys(hardwareDetails).includes('wifiKitShipped')) ? false : true, message: "Please input wifi kit shipped!" }]}>
          <Select   
          disabled = {!Object.keys(hardwareDetails).includes('wifiKitShipped')}
                      // value={locationDetails?.country}
                      onChange={(value) => {
                        setHardwareDetails((prev) => ({
                          ...prev,
                          wifiKitShipped: value,
                        }));
                      }}
                      placeholder="Wifi Kit Shipped"
                      allowClear
                    >
                        <Option value="Yes">Yes</Option>
                        <Option value="No">No</Option>
                    </Select>
        </Form.Item>

        <Form.Item
          name="wifiShippedDate"
          label="Wifi Shipped Date"
          rules={[{ required: (!Object.keys(hardwareDetails).includes('wifiShippedDate')) ? false : true, message: "Please input wifi shipped date!" }]}
        >
          <DatePicker
          disabled = {!Object.keys(hardwareDetails).includes('wifiShippedDate')}
           onChange={(date)=>{
            setHardwareDetails(prev => ({
              ...prev,
              wifiShippedDate: date ? new Date(date) : null
            }))
          }}/>
        </Form.Item>

        <Form.Item
          name="wifiInstallDate"
          label="Wifi Install Date"
          rules={[{ required: (!Object.keys(hardwareDetails).includes('wifiInstallDate')) ? false : true, message: "Please input wifi delivery date!" }]}
        >
          <DatePicker
          disabled = {!Object.keys(hardwareDetails).includes('wifiInstallDate')}
           onChange={(date)=>{
            setHardwareDetails(prev => ({
              ...prev,
              wifiInstallDate: date ? new Date(date) : null
            }))
          }}/>
        </Form.Item>

        <Form.Item name="wifiInstalled" label="WIFI Installed?">

          <Select value={hardwareDetails.wifiInstalled} onChange={value => setHardwareDetails(prev => ({
            ...prev,
            wifiInstalled: value
          }))}>
            <Option value={true}>Yes</Option>
            <Option value={false}>No</Option>

          </Select>

          {/* <Checkbox
            disabled = {!Object.keys(hardwareDetails).includes('wifiInstalled')}
            onChange={(e) => {
                setHardwareDetails(prev => ({
                  ...prev,
                  wifiInstalled: e.target.checked
              }));
              
            }}
          >
            {" "}
            Wifi Installed.
          </Checkbox> */}
        </Form.Item>


        <h6>Signage Details</h6>



            <Form.Item name="signageOrdered" label="Signage Ordered?" >

              <Select value={hardwareDetails.signageOrdered} onChange={value => setHardwareDetails(prev => ({
            ...prev,
            signageOrdered: value
          }))}>
            <Option value={true}>Yes</Option>
            <Option value={false}>No</Option>

          </Select>

          {/* <Checkbox
            onChange={(e) => {
                setHardwareDetails(prev => ({
                  ...prev,
                  signageOrdered: e.target.checked
              }));
              
            }}
          >
            {" "}
            Signage Ordered.
          </Checkbox> */}
        </Form.Item>

         

        <Form.Item
          name="signageShippedDate"
          label="Signage Shipped Date"
          rules={[{ required: true, message: "Please input signage shipped date!" }]}
        >
          <DatePicker onChange={(date)=>{
            setHardwareDetails(prev => ({
              ...prev,
              signageShippedDate: date ? new Date(date) : null
            }))
          }}/>
        </Form.Item>

        <Form.Item
          name="signageInstallDate"
          label="Signage install Date"
          rules={[{ required: true, message: "Please input signage install date!" }]}
        >
          <DatePicker onChange={(date)=>{
            setHardwareDetails(prev => ({
              ...prev,
              signageInstallDate: date ? new Date(date) : null
            }))
          }}/>
        </Form.Item>

        <Form.Item name="signageInstalled" label="Signage Installed?" >
          <Select value={hardwareDetails.signageInstalled} onChange={value => setHardwareDetails(prev => ({
            ...prev,
            signageInstalled: value
          }))}>
            <Option value={true}>Yes</Option>
            <Option value={false}>No</Option>

          </Select>
          {/* <Checkbox
            onChange={(e) => {
                setHardwareDetails(prev => ({
                  ...prev,
                  signageInstalled: e.target.checked
              }));
              
            }}
          >
            {" "}
            Signage Installed.
          </Checkbox> */}
        </Form.Item>


        <h6>Lettering Details</h6>
        
            <Form.Item name="letteringOrdered" label="Lettering Ordered?">
              <Select value={hardwareDetails.letteringOrdered} onChange={value => setHardwareDetails(prev => ({
            ...prev,
            letteringOrdered: value
          }))}>
            <Option value={true}>Yes</Option>
            <Option value={false}>No</Option>

          </Select>
          {/* <Checkbox
            onChange={(e) => {
                setHardwareDetails(prev => ({
                  ...prev,
                  letteringOrdered: e.target.checked
              }));
              
            }}
          >
            {" "}
            Lettering Ordered.
          </Checkbox> */}
        </Form.Item>

         

        <Form.Item
          name="letteringShippedDate"
          label="Lettering Shipped Date"
          rules={[{ required: true, message: "Please input lettering order date!" }]}
        >
          <DatePicker onChange={(date)=>{
            setHardwareDetails(prev => ({
              ...prev,
              letteringShippedDate: date ? new Date(date) : null
            }))
          }}/>
        </Form.Item>

        <Form.Item
          name="letteringInstallDate"
          label="Lettering Install Date"
          rules={[{ required: true, message: "Please input lettering delivery date!" }]}
        >
          <DatePicker onChange={(date)=>{
            setHardwareDetails(prev => ({
              ...prev,
              letteringInstallDate: date ? new Date(date) : null
            }))
          }}/>
        </Form.Item>

        <Form.Item name="letteringInstalled" label="Lettering Installed?" >

          <Select value={hardwareDetails.letteringInstalled} onChange={value => setHardwareDetails(prev => ({
            ...prev,
            letteringInstalled: value
          }))}>
            <Option value={true}>Yes</Option>
            <Option value={false}>No</Option>

          </Select>
          {/* <Checkbox 
            onChange={(e) => {
                setHardwareDetails(prev => ({
                  ...prev,
                  letteringInstalled: e.target.checked
              }));
              
            }}
          >
            {" "}
            Lettering Installed.
          </Checkbox> */}
        </Form.Item>






        {isApprover && isApproverView && <Form.Item className={Styles["full-width"]} name="isSectionCompleted" valuePropName="checked">
          <Checkbox
            disabled={
              Object.values(hardwareDetails).filter((value) => value !== null)
                .length /
                Object.values(hardwareDetails).length <
                1 || hardwareDetails?.isSectionCompleted
            }
            onChange={(e) => {
              submitForm(e.target.checked);
            }}
          >
            {" "}
            Verified and Completed.
          </Checkbox>
        </Form.Item>}
      </Form>
    </div>
  );
};
export default HardwareDetailsComponent;
